module.exports = __webpack_public_path__ + "static/media/logo.ce8ead3b.png";